import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./footerStyle.css";
import "aos/dist/aos.css";

export default function Footer() {
    const navigate = useNavigate();

    useEffect(() => {
    }, []);

    function switchSide(side) {
        navigate(side);
    }

    return (
        <div className="footerContainer">
            <h1 onClick={() => switchSide("/impressum")}>Impressum</h1>
            <h2 onClick={() => switchSide("/datenschutz")}>Datenschutz</h2>
            <h3>© DJ - EMAN 2025 - 2026</h3>
        </div>
    )
}
